import { useLanguage } from "@/context/LanguageContext";
import { InteractiveMap } from "@/components/site/InteractiveMap";
import { Reveal } from "@/components/site/Reveal";

export default function MapPage() {
  const { t } = useLanguage();

  return (
    <div data-testid="map-page" className="pt-24 md:pt-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.24em] text-lagoon">
            <span className="h-px w-10 bg-lagoon" />
            {t.map.overline}
          </p>
          <h1 className="mt-4 font-serif text-4xl tracking-tight text-ink sm:text-5xl lg:text-6xl">
            {t.map.title}
          </h1>
          <p className="mt-4 max-w-md text-base text-ink/60">{t.map.hint}</p>
        </Reveal>
        <div className="mt-10 pb-16 md:mt-16 md:pb-24">
          <InteractiveMap />
        </div>
      </div>
    </div>
  );
}
